import { render, staticRenderFns } from "./BestandsVorgaenge.vue?vue&type=template&id=5a20de3c&"
import script from "./BestandsVorgaenge.vue?vue&type=script&lang=js&"
export * from "./BestandsVorgaenge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports